import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button, Grid, Typography } from '@mui/material'
import { debounce } from 'lodash';
import { getProfile, updateProfile } from 'redux/actions/UserProfile';
import CommonCropImage from 'components/CommonCropImage/CommonCropImage';
import CommonForm from 'components/commonForm/CommonForm';
import CommonOtpDialog from 'components/commonOtpDialog/CommonOtpDialog';
import Loader from 'components/loader/Loader';
import { fileSizeObject, toastObject } from 'utils/enumObject';
import useModal from 'components/hook/useModal';
import { getLogout } from 'redux/actions/UserLogout';
import { profileData } from './ProfileData';
import { emailReg } from 'utils/Regex';
import camera from 'assets/images/camera.svg';
import profile from 'assets/images/profileImg.svg';
import editIcon from 'assets/images/whiteEdit.svg';



function Profile() {
  const [imgError, setImgError] = useState("");
  const [fileTypeError, setFileTypeError] = useState("");
  const [edit, setEdit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [imageObj, setImageObj] = useState({});
  const [src, setSrc] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editIconClicked, setEditIconClicked] = useState(false);
  const [name, setName] = useState('')
  const [keyname, setKeyName] = useState('');
  const [verify,setVerify] = useState({mobile:false,email:false})
  const [otpDialog, setOtpDialog] = useState(false);
  const { open, toggle } = useModal();

  const verifyOtpData = useSelector((state) => state.userVerifyProfile);
 
  useEffect(()=>{
     if(verifyOtpData?.userVerifyProfile?.success === true){
       setEditIconClicked(false)
     }
    },[verifyOtpData])
  const userProfileData = useSelector(
    (state) => state?.userProfile?.userProfile?.data
  );
  const profileLoader =  useSelector((state) => state?.userProfile?.loading)
 const defaultValues = {
  firstName:userProfileData?.firstName || '',
  lastName:userProfileData?.lastName || '',
  email:userProfileData?.email || '',
  mobile:userProfileData?.mobile || ''
 }
 useEffect(()=>{
   if(!defaultValues?.email && !defaultValues?.mobile){
    setVerify({mobile:false,email:false})
   }
   else{
    setVerify({mobile:true,email:true})
   }
 },[userProfileData])
 
  const [image, setImage] = useState(
    userProfileData?.avatar?.url && userProfileData?.avatar != null
      ? userProfileData?.avatar?.url
      : null
  );
  const handleClose = () =>{
    setOpenDialog(false)
    setEditIconClicked(false)
    toggle()
    dispatch(getProfile())
  }
  const dispatch = useDispatch();
  const onLogout = () =>{
    dispatch(getLogout());  
  }
  const handleCropSave = (blob, img) => {
    setImage(URL.createObjectURL(blob));
    let formData = new FormData();
    const file = new File([blob], imageObj?.name, { lastModified: new Date() });
    formData.append("avtar", file);
    dispatch(updateProfile(formData));
  };

  const handleErrorImg = (event) => {
    const typeError = 'Please choose proper image'
    setFileTypeError(typeError)
    setModalOpen(false)
  }
  const onImageChange = (event) => {
    setFileTypeError("");
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImageObj(event.target.files[0]);
      const attributeType = ["image/jpeg", "image/png"];

      if (!attributeType.includes(img.type)) {
        const typeError = "File type should be in png/jpg/jpeg";
        setFileTypeError(typeError);
      } else if (event.target.files[0].size > fileSizeObject.fileSize) {
        const errorVal = "Image size should not be more than 1 MB";
        setImgError(errorVal);
      } else {
        setFileTypeError("");
        setSrc(URL.createObjectURL(img));
        setModalOpen(true);
      }
    }
  };
  const handleEditIconClick = () => {
    setEditIconClicked(false);
  };
  const onVerifyProfile = (data, code) => {
    setOtpDialog(false);
    setEditIconClicked(false);
    const val = {
      firstName:data?.firstName,
      lastName:data?.lastName,
    };
    dispatch(updateProfile(val));
  };
  const toggleEditMode = () => {
    setEditIconClicked(!editIconClicked);
    setEdit(!edit);
  };
 
  const editProfile = () => {
    const updatedProfile = profileData.map((section) => ({
      ...section,
      profile: section.profile.map((field) => ({
        ...field,
        disabled: false,
      })),
    }));
  
    return updatedProfile;
  };

  const onHandleInput = debounce((e,keyName) =>{
    setKeyName(keyName)
  if(keyName === 'mobile' && e.target.value.length === 10 )
    {
      setName(e.target.value)
      setOpenDialog(true)
      const val = {
        mobile : e.target.value,
        countryCode:'+91'
      };
      dispatch(updateProfile(val,toggle));
    }
    else if(keyName === 'email' )
    {
      if( emailReg.test(e.target.value)){
        setName(e.target.value)
        setOpenDialog(true)
        const val = {
          email : e.target.value,
        };
        dispatch(updateProfile(val,toggle));
      }
      else{
        setOpenDialog(false)
      }    
    }
    
  },1000);

  return (
    <>
       <Grid container className='marginLeft60' md={11} xs={11}>
         <Grid item container
         alignItems='end'
         justifyContent='space-between'>
          <Grid item className='fontSize'>
          <Typography className='font28 fontMedium pb10'>Account Info</Typography>
          </Grid>
          <Grid item>
            <Button 
            variant="contained"
            size="medium"
            fullWidth
            className='logout'
            onClick={onLogout}
            >Logout</Button>
          </Grid>
         </Grid>
         <Grid item container
         className='profileBg marginTop height80p'> 
            <Grid
                    className="mtlb60r85"
                    container
                    direction="column"
                    justifyContent="flex-start"
                    md={12}
                  >
                   
                    <Grid item container className="dpTextStyle" justifyContent='space-between' alignItems='end'>
                      <Grid item>
                      Your Profile Picture
                        </Grid> 
                   <Grid item justifyContent='end' className={`${editIconClicked && 'visibilityHidden'}`}>
                      <Button className='primaryBtn'
                     onClick={toggleEditMode}
                     > <img src={editIcon} alt="edit" className='marginRight8'/> Edit</Button>
                    </Grid>
                    </Grid>
                    <Button
                    component="label"
                      className="uploadBtn"
                    >
                      <CommonCropImage
                        modalOpen={modalOpen}
                        src={src}
                        setModalOpen={setModalOpen}
                        handleCropSave={handleCropSave}
                      />
                      <img
                        src={
                          image && image != null
                            ? image
                            : userProfileData?.avtar?.url &&
                              userProfileData?.avtar != null
                            ? userProfileData?.avtar?.url
                            : profile
                        }
                        alt="profile"
                        className="imgFormSize"
                      />
                      {src && <img
                        src={src}
                        alt="profile"
                        className="imgFormSize"
                        style={{display:'none'}}
                        onError={handleErrorImg}
                      />}
                      <div className="imgOuter">
                        <img src={camera} alt="camera" />
                      </div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => onImageChange(e)}
                        hidden
                      />
                    </Button>
                    {imgError && imgError !== null && (
                      <div className="errorMessage">{imgError}</div>
                    )}
                    {fileTypeError && fileTypeError !== null && (
                      <div className="errorMessage">{fileTypeError} </div>
                    )}
                    {profileLoader ? <Loader /> :
                    <CommonForm
                      formData={editIconClicked ? editProfile() : profileData}
                      onHandleClose={handleEditIconClick}
                      onHandleInput={onHandleInput}
                      onSubmittBtn={onVerifyProfile}
                      selectType={editIconClicked ? 'edit' : null}
                      button={editIconClicked ? 'dialogButton' : null}
                      size={editIconClicked ? '6': null}
                      defaultValues={defaultValues}
                      verify={verify}
                    /> }
                  </Grid>
         </Grid>
       </Grid>

    {open &&  <CommonOtpDialog
       key={name}  
      open={open} 
      handleClose={handleClose}
      value={name}
      countryCode={(keyname === 'mobile' && toastObject?.countryCode)|| ''}
       /> }
    </>
  )
}

export default Profile
